/**
 * Module dependencies.
 */

import { Navigate } from 'react-router-dom';
import { appRoutes } from 'app/routes';
import { useMe } from 'app/hooks/requests/use-me';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  feature: string;
  children: JSX.Element;
};

/**
 * Export `FeatureGuard` component.
 *
 * Renders `children` only when the feature is enabled for the current user;
 * otherwise redirects to the dashboard home. Waits for `/me` before deciding so
 * a disabled feature never flashes and an enabled one is never wrongly blocked.
 */

export function FeatureGuard({ feature, children }: Props): JSX.Element | null {
  const { data: me, isLoading } = useMe();

  if (isLoading || !me) {
    return null;
  }

  if (!me.features?.[feature]) {
    return <Navigate replace to={appRoutes.dashboard.home.base} />;
  }

  return children;
}
